import CheckBoxWithIcon from './CheckBoxWithIcon';

export default CheckBoxWithIcon;
